export const getLoireData = () => ({
  name: "Loire",
  country: "France",
  description: "La Vallée de la Loire, surnommée le Jardin de la France, est la plus grande région viticole française. Elle s'étend sur 1000 km le long du fleuve et produit une incroyable diversité de vins, des vins blancs secs et aromatiques aux vins rouges élégants, en passant par des vins effervescents et des vins doux.",
  type: "region",
  mapAreas: [
    { region: "Loire", x: 30, y: 55, color: "#4B164C", size: 7 }
  ],
  statistics: {
    totalArea: "70,000 ha",
    production: "3.5 million hectolitres",
    appellations: "87 appellations",
    departments: "14 départements",
    exportPercentage: "20%"
  },
  characteristics: {
    climate: "Climat océanique tempéré avec des influences continentales vers l'est",
    soil: "Sols très variés : tuffeau, schiste, sable, argile, calcaire",
    viticulture: "Viticulture traditionnelle, respect de l'environnement, vins de terroir"
  },
  wineStyles: {
    white: "Vins blancs secs et aromatiques, de la fraîcheur à la complexité",
    red: "Vins rouges élégants et fruités, tannins soyeux",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de qualité, méthode traditionnelle",
    sweet: "Vins doux et liquoreux, concentrés et complexes"
  },
  history: "La viticulture dans la Loire remonte à l'époque romaine. Au Moyen Âge, les moines ont développé les techniques viticoles. La Renaissance a vu l'émergence des châteaux et des domaines prestigieux. Aujourd'hui, la Loire est reconnue pour sa diversité et sa qualité.",
  foodPairing: "Fruits de mer, poissons, volailles, fromages de chèvre, cuisine française traditionnelle",
  subregions: {
    "nantes": {
      name: "Nantes",
      description: "Région côtière produisant principalement du Muscadet, des vins blancs secs et minéraux parfaits pour les fruits de mer.",
      characteristics: {
        climate: "Climat océanique frais et humide",
        soil: "Sols de gneiss, granit et schiste",
        viticulture: "Vendanges manuelles, élevage sur lies"
      },
      grapeVarieties: {
        white: ["Melon de Bourgogne", "Folle Blanche", "Gros Plant"]
      },
      wineStyles: {
        "muscadet": "Vins blancs secs et minéraux",
        "gros-plant": "Vins blancs secs et vifs"
      },
      foodPairing: "Fruits de mer, poissons, huîtres, moules"
    },
    "anjou-saumur": {
      name: "Anjou-Saumur",
      description: "Région centrale produisant des vins rouges, blancs et rosés de qualité, ainsi que des vins effervescents.",
      characteristics: {
        climate: "Climat océanique tempéré",
        soil: "Sols de tuffeau, schiste et argile",
        viticulture: "Viticulture traditionnelle et moderne"
      },
      grapeVarieties: {
        red: ["Cabernet Franc", "Cabernet Sauvignon", "Grolleau"],
        white: ["Chenin Blanc", "Chardonnay", "Sauvignon Blanc"]
      },
      wineStyles: {
        "anjou-rouge": "Vins rouges fruités et élégants",
        "saumur-blanc": "Vins blancs secs et aromatiques",
        "rose-danjou": "Rosés frais et fruités"
      },
      foodPairing: "Viandes blanches, poissons, fromages, cuisine traditionnelle"
    },
    "touraine": {
      name: "Touraine",
      description: "Région du centre produisant des vins rouges et blancs de qualité, avec une forte identité terroir.",
      characteristics: {
        climate: "Climat océanique avec influence continentale",
        soil: "Sols de tuffeau, argile et sable",
        viticulture: "Viticulture de terroir, rendements limités"
      },
      grapeVarieties: {
        red: ["Cabernet Franc", "Cabernet Sauvignon", "Malbec"],
        white: ["Chenin Blanc", "Sauvignon Blanc"]
      },
      wineStyles: {
        "chinon": "Vins rouges élégants et fruités",
        "vouvray": "Vins blancs secs et moelleux",
        "bourgueil": "Vins rouges structurés et tanniques"
      },
      foodPairing: "Viandes rouges, volailles, fromages, cuisine française"
    },
    "centre": {
      name: "Centre",
      description: "Région orientale produisant principalement du Sauvignon Blanc, des vins blancs secs et aromatiques de renommée mondiale.",
      characteristics: {
        climate: "Climat continental avec influence océanique",
        soil: "Sols de calcaire, argile et silex",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Sauvignon Blanc", "Chardonnay"],
        red: ["Pinot Noir", "Gamay"]
      },
      wineStyles: {
        "sancerre": "Vins blancs secs et aromatiques",
        "pouilly-fume": "Vins blancs secs et minéraux",
        "menetou-salon": "Vins blancs secs et élégants"
      },
      foodPairing: "Poissons, fruits de mer, fromages de chèvre, cuisine légère"
    }
  }
}); 